import ProductsRouter from "./Products.router";

export default ProductsRouter;
